import React, { useState, useEffect, useRef } from 'react';
import { TextField } from '@mui/material';

/**
 * CommentCell component to handle delayed save of comment edits
 */
const CommentCell = React.memo(({ id, value, onSave }) => {
  const [localValue, setLocalValue] = useState(value || '');
  const timeoutRef = useRef(null);
  const inputRef = useRef(null);
  
  useEffect(() => {
    if (document.activeElement !== inputRef.current) {
      setLocalValue(value || '');
    }
  }, [value]);

  const handleChange = (e) => {
    e.stopPropagation();
    const newValue = e.target.value;
    setLocalValue(newValue);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      onSave(id, newValue);
    }, 500);
  };

  const handleKeyDown = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <TextField
      inputRef={inputRef}
      size="small"
      value={localValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onClick={(e) => e.stopPropagation()}
      fullWidth
      variant="outlined"
    />
  );
});

export default CommentCell;